import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { NgForOf, NgIf } from "@angular/common";
import { IconComponent } from "../../elements/icon/icon.component";
import { Icons } from "../../../model/icon";
import { ApiService } from "../../../services/api.service";
import {FormsModule} from "@angular/forms";
import {getImageUrl} from "../../../functions/getImageUrl";
import {OldMapComponent} from "../../elements/old-map/old-map.component";
import {MapFilter} from "../../../model/chronology";
import {articleNew} from "../../../model/toLoad";
import {logObjectAsConst} from "../../../functions/test";
import {Article, MapPoints} from "../../../model/article";
import {eventTypes, PointData} from "../../../model/pointData";
import {AutocompleteInputComponent} from "../../elements/autocomplete-input/autocomplete-input.component";

interface ServerResponse<T> {
  content: T[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

@Component({
  selector: 'app-admin',
  imports: [
    NgForOf,
    IconComponent,
    NgIf,
    FormsModule,
    OldMapComponent,
    AutocompleteInputComponent
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) private fileInput!: ElementRef;
  @ViewChild(OldMapComponent) oldMapComponent!: OldMapComponent;

  constructor(private apiService: ApiService) {}

  tabs = ['Хронология', 'Статьи', 'Герои', 'Факты', 'Карта'];
  activeTabIndex = 0;
  currentData: any[] = [];
  totalItems = 0;
  currentPage = [1, 1, 1, 1, 1];
  pageSize = 10;
  loading = false;
  editMode: boolean = false;
  currentItem: any = null;
  searchQuery: string = '';

  fileChangeType: any;
  fileIndex: number = -1;

  files: File[] = [];
  additionalStyle: boolean = false;

  filter: MapFilter = new MapFilter();
  editMap: boolean = false;

  article: Article = new Article();
  newArticle: Article = new Article();
  mapPoints: MapPoints = new MapPoints();
  articleTitle: string = '';
  mapPointsTitle: string = '';
  errorMapPoint: boolean = false;
  addPointFlag: boolean = false;

  articles: Article[] = [];

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    const endpointMap = [
      'public/chronology',
      'public/newspaper',
      'public/hero', // Исправлен endpoint для героев
      'public/fact',
      '' // Для карты
    ];

    if (this.activeTabIndex === 4) { // Карта
      this.currentData = [];
      this.totalItems = 0;
      this.loading = false;
      this.apiService.getPaginatedData('public/chronology', 1, 1000, '').subscribe((data) => {
        this.articles = data.content.map((v: any) => new Article(v));
        setTimeout(() => {
          this.oldMapComponent.filter(this.filter.search ?? '', this.articles );
        }, 500);
      });
      return;
    }
    this.files = [];
    this.apiService.getPaginatedData(
        endpointMap[this.activeTabIndex],
        this.currentPage[this.activeTabIndex],
        this.pageSize,
        this.searchQuery
    ).subscribe({
      next: data => this.handleResponse(data),
      error: () => this.loading = false
    });
  }

  private handleResponse(data: ServerResponse<any>) {
    this.currentData = data.content;
    this.totalItems = data.page.totalElements;
    this.loading = false;
    this.currentPage[this.activeTabIndex] = data.page.number + 1;
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.currentPage[index] = 1;
    this.searchQuery = '';
    this.editMode = false;
    this.currentItem = null;
    this.loadData();
  }

  changePage(delta: number) {
    const newPage = this.currentPage[this.activeTabIndex] + delta;
    const totalPages = Math.ceil(this.totalItems / this.pageSize);

    if (newPage < 1 || newPage > totalPages) return;

    this.currentPage[this.activeTabIndex] = newPage;
    this.loadData();
  }

  // Новые методы для работы с элементами
  openItem(item?: any) {
    if (item) {
      const endpointMap = [
        'chronology',
        'newspaper',
        'hero',
        'fact',
        ''
      ];

      this.loading = true;
      this.apiService.getItem(endpointMap[this.activeTabIndex], item.id)
          .subscribe({
            next: (data) => {
              this.currentItem = data;
              this.editMode = true;
              this.loading = false;
            },
            error: () => this.loading = false
          });
    } else {
      this.currentItem = {};
      this.editMode = true;
    }
  }

  saveItem() {
    if (!this.currentItem) return;

    this.loading = true;
    const endpointMap = [
      'chronology',
      'newspaper',
      'hero',
      'fact',
      'chronology'
    ];

    if ((this.activeTabIndex == 1 || this.activeTabIndex == 2 || this.activeTabIndex == 3) && !this.currentItem.image) {
      this.currentItem.image = '';
    }
    if (this.activeTabIndex == 2 ) {
      this.currentItem.miniText = '';
    }

    const observable = this.apiService.createItem(endpointMap[this.activeTabIndex], this.currentItem);

    observable.subscribe({
      next: (data) => {
        if (this.files.length > 0) {
          if (endpointMap[this.activeTabIndex] == 'chronology') {
            this.saveFiles(endpointMap[this.activeTabIndex], data.id, 0);
          } else {
            this.uploadFile(data.id);
          }
        }
        this.loadData();
        this.editMode = false;
        this.currentItem = null;
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  saveFiles(endpoint: string, id: number, index: number) {
    this.apiService.uploadFile(endpoint, id, this.files[index]).subscribe(() => {
      if (index + 1 < this.files.length) {
        this.saveFiles(endpoint, id, index + 1);
      } else
        this.files = [];
    });
  }

  cancelEdit() {
    this.editMode = false;
    this.currentItem = null;
  }

  deleteItem(item: any) {
    if (confirm(`Удалить "${item.title || item.name}"?`)) {
      const endpointMap = [
        'chronology',
        'newspaper',
        'hero',
        'fact',
        ''
      ];

      this.loading = true;
      this.apiService.deleteItem(endpointMap[this.activeTabIndex], item.id)
          .subscribe({
            next: () => this.loadData(),
            error: () => this.loading = false
          });
    }
  }

  moveItem(item: any, direction: 'up' | 'down') {
    const endpointMap = [
      'chronology',
      'newspaper',
      'hero',
      'fact',
      ''
    ];

    const observable = direction === 'up' ?
        this.apiService.moveUp(endpointMap[this.activeTabIndex], item.id) :
        this.apiService.moveDown(endpointMap[this.activeTabIndex], item.id);

    observable.subscribe(success => {
      if (success) this.loadData();
    });
  }

  search() {
    this.currentPage[this.activeTabIndex] = 1;
    this.loadData();
  }

  clearSearch() {
    this.searchQuery = '';
    this.loadData();
  }

  onInput(textarea: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  setImage() {
    this.fileInput.nativeElement.click();
  }

  onFileChange() {
    const input = this.fileInput.nativeElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          switch (this.activeTabIndex) {
            case 0: {
              this.setChronologyFile(file);
              break;
            }
            case 1:
            case 2:
            case 3: {
              this.setAnotherFile(file);
              break;
            }
          }
        };
        reader.readAsDataURL(file);
        this.fileReset();
      } else {
        // this.errorMessage = 'Пожалуйста, выберите файл изображения.';
        // this.imageUrl = null;
      }
    }
  }

  fileReset() {
    this.fileInput.nativeElement.value = '';
  }

  setChronologyFile(file: File) {
    this.files.push(file);
  }

  setAnotherFile(file: File) {
    this.files[0] = file;
  }

  uploadFile(id: number) {
    const endpointMap = [
      'chronology',
      'newspaper',
      'hero',
      'fact',
      ''
    ];
    this.loading = true;
    this.apiService.uploadFile(endpointMap[this.activeTabIndex], id, this.files[0])
        .subscribe({
          next: () => this.loadData(),
          error: () => this.loading = false
    });
  }

  setClearImages() {
    if (this.currentItem.id && this.currentItem.images.length > 0) {
      this.clearImages(this.currentItem.id, this.currentItem.images.length - 1);
    }
  }

  clearImages(id: number, index: number) {
    this.apiService.deleteFileChronology(id, index).subscribe(() => {
      if (index > 0) {
        this.clearImages(id, index - 1);
      } else {
        this.openItem(this.currentItem);
      }
    });
  }

  createObjUrl(file: File) {
    return URL.createObjectURL(file);
  }

  closeMapEdit() {
    this.editMap = false;
    this.addPointFlag = false;
    this.article = new Article();
    this.newArticle = new Article();
    this.articleTitle = '';
    this.mapPointsTitle = '';
  }


  deletePoint() {
    const idx = this.article.mapPoints?.findIndex(v => v.id == this.mapPoints.id);
    if (idx && idx > -1) {
      this.article.mapPoints?.splice(idx, 1);
      this.apiService.createItem('chronology', this.article).subscribe(() => {
        this.editMap = false;
        this.loadData();
      });
    }
  }

  savePoint() {
    if (!this.articleTitle || !this.mapPointsTitle) {
      this.errorMapPoint = true;
    } else {
      if (this.addPointFlag) {
        this.mapPoints.chronologyId = this.newArticle.id;
        this.newArticle.mapPoints?.push(this.mapPoints);
        this.apiService.createItem('chronology', this.newArticle).subscribe(() => {
          this.editMap = false;
          this.addPointFlag = false;
          this.article = new Article();
          this.mapPoints = new MapPoints();
          this.loadData();
        });
      } else {
        let idx = this.article.mapPoints?.findIndex(v => v.id == this.mapPoints.id);
        if (idx != undefined && idx > -1 && this.article.mapPoints) {
          this.article.mapPoints[idx] = this.mapPoints;
          if (this.newArticle.id == this.article.id || this.newArticle.id == -1) {
            this.apiService.createItem('chronology', this.article).subscribe(() => {
              this.editMap = false;
              this.loadData();
            });
          } else {
            this.article.mapPoints.splice(idx, 1);
            this.mapPoints.chronologyId = this.newArticle.id;
            delete this.mapPoints.id;
            this.newArticle.mapPoints?.push(this.mapPoints);
            this.apiService.createItem('chronology', this.article).subscribe(() => {
              this.apiService.createItem('chronology', this.newArticle).subscribe(() => {
                this.editMap = false;
                this.loadData();
              });
            });
          }
        }
      }
    }
  }

  addPoint(point: {lat: number, lng: number}) {
    this.addPointFlag = true;
    this.editMap = true;
    this.article = new Article();
    this.mapPoints = new MapPoints();
    this.mapPoints.latitude = point.lat;
    this.mapPoints.longitude = point.lng;
  }

  editPoint(data: PointData) {
    this.editMap = true;
    this.article = data.art;
    this.mapPoints = data.point;
    this.articleTitle = data.art.subTitle ?? '';
    this.mapPointsTitle = eventTypes.find(v => v.key == data.point.icon)?.title ?? '';
  }

  emitArticle(art: Article | null) {
    if (art == null) {
      this.errorMapPoint = true;
      this.articleTitle = '';
    } else {
      this.newArticle = art;
      this.articleTitle = this.newArticle.subTitle ?? '';
      this.errorMapPoint = this.articleTitle == '' || this.mapPointsTitle == '';
    }
  }

  emitMapPointsType(type: {key: string, title: string} | null) {
    if (type == null) {
      this.errorMapPoint = true;
      this.mapPointsTitle = '';
    } else {
      this.mapPoints.icon = type.key;
      this.mapPointsTitle = eventTypes.find(v => v.key == this.mapPoints.icon)?.title ?? '';
      this.errorMapPoint = this.articleTitle == '' || this.mapPointsTitle == '';
    }
  }


  protected readonly Math = Math;
  protected readonly Icons = Icons;
  protected readonly getImageUrl = getImageUrl;
  protected readonly eventTypes = eventTypes;
}